'use client';

import { useParams } from 'next/navigation';
import { resolveWebLanguageCode, type WebLanguageCode } from '../modules/intl/language';

export const useClientLocale = (): { languageCode: WebLanguageCode } => {
  const params = useParams<{ locale?: string }>();
  return { languageCode: resolveWebLanguageCode(params.locale) };
};
